var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"auth-view screen"},[_c('div',{staticClass:"auth-header"},[_c('white-nav-bar',{attrs:{"route-name":"login","back-or-close":"close"}},[_vm._v("Authenticating user...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }